import { BaseSearchInput } from '@capsicum/common-web';
import { memo } from 'react';
import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.backgrounds.main.screen};
	flex: 1;
	display: flex;
	flex-direction: column;
	padding-top: ${({ theme }) => theme.spacings.large};
	padding-inline: ${({ theme }) => theme.spacings.small};
`;

export const AssetList = styled.div`
	flex: 1;
	contain: content;
	padding-bottom: ${({ theme }) => theme.sizing.xxlarge};
`;

export const ListRow = styled.div<{ $show: boolean }>`
	contain: strict;
	content-visibility: auto;
	display: ${({ $show }) => ($show ? 'flex' : 'none')};
	flex-direction: column;
`;

export const CardContainer = styled(ListRow)`
	margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
	height: ${({ theme }) => `calc(${theme.sizing.xlargeTop} + ${theme.spacings.small} * 2)`};
`;

export const FanTokensTitleContainer = styled(ListRow)`
	height: 1lh;
	margin-block: ${({ theme }) => theme.spacings.small};
`;

export const Search = memo(styled(BaseSearchInput)`
	margin-top: ${({ theme }) => theme.spacings.medium};
	margin-bottom: ${({ theme }) => theme.spacings.large};
`);
